import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { NgModel } from '@angular/forms';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-select-check-all',
  template: `
    <mat-checkbox
      class="mat-option"
      [disableRipple]="true"
      [indeterminate]="isIndeterminate()"
      [checked]="isChecked()"
      (click)="$event.stopPropagation()"
      (change)="toggleSelection($event)"
    >
      {{ text }}
    </mat-checkbox>
  `,
  styleUrls: ['./choose-outlet.component.css'],
})
export class SelectCheckAllComponent implements OnInit, OnDestroy {
  @Input() model: NgModel;
  @Input() values = [];
  @Input() text = 'Select All';
  @Input() designationList: boolean;
  @Input() settlement: boolean;
  subscription = new Subscription();
  constructor(private translate: TranslateService) {}

  ngOnInit() {
    this.subscription.add(
      this.translate.get(['SELECT_ALL']).subscribe((res) => {
        this.text = res.SELECT_ALL;
      })
    );
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  isChecked(): boolean {
    return (
      this.model.value &&
      this.values.length &&
      this.model.value.length === this.values.length
    );
  }

  isIndeterminate(): boolean {
    return (
      this.model.value &&
      this.values.length &&
      this.model.value.length &&
      this.model.value.length < this.values.length
    );
  }

  toggleSelection(change: MatCheckboxChange): void {
    if (change.checked) {
      if (this.designationList) this.model.update.emit([...this.values]);
      else if (this.settlement) {
        let settlementEnabled = [
          ...this.values.filter((item) => {
            if (
              item.settings &&
              item.settings.settlement &&
              item.settings.settlement.visible
            )
              return true;
            else false;
          }),
        ];
        this.model.update.emit([...settlementEnabled.map((item) => item.id)]);
      } else this.model.update.emit([...this.values.map((item) => item.id)]);
    } else {
      this.model.update.emit([]);
    }
  }
}
